/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/portugal.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Retopo_NurbsPath025.geometry}
				material={materials["Material.014"]}
				position={[-2.494, 0.185, 1.465]}
				rotation={[Math.PI / 2, -Math.PI / 2, 0]}
				scale={0.139}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube111.geometry}
				material={materials["Material.014"]}
				position={[0.012, 0, -0.003]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane017.geometry}
				material={materials["Material.014"]}
				position={[-0.061, 0.252, -0.045]}
				scale={0.032}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube112.geometry}
				material={materials["Material.014"]}
				position={[-0.072, 0, -0.018]}
				scale={[1, 0.805, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube113.geometry}
				material={materials["Material.014"]}
				position={[-0.164, 0.312, 2.132]}
			/>
			<group
				position={[-0.305, 0.015, -1.992]}
				rotation={[0, -0.008, 0]}
				scale={0.608}
			>
				<mesh
					castShadow
					receiveShadow
					geometry={nodes.Plane018.geometry}
					material={materials["Material.016"]}
				/>
				<mesh
					castShadow
					receiveShadow
					geometry={nodes.Plane018_1.geometry}
					material={materials["Material.015"]}
				/>
			</group>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube114.geometry}
				material={materials["Material.014"]}
				position={[-1.874, 0.039, -1.898]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder051.geometry}
				material={materials["Material.014"]}
				position={[-2.357, 0.099, -2.072]}
				scale={[0.465, 0.068, 0.465]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder052.geometry}
				material={materials["Material.014"]}
				position={[-1.388, 0.099, -2.072]}
				scale={[0.465, 0.068, 0.465]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube115.geometry}
				material={materials["Material.014"]}
				position={[1.877, 0.972, 1.098]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube116.geometry}
				material={materials["Material.014"]}
				position={[1.886, 0.61, 1.273]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane020.geometry}
				material={materials["Material.014"]}
				position={[-0.209, 0.08, -0.98]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane021.geometry}
				material={materials["Material.014"]}
				position={[-0.004, 0.08, -0.796]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane022.geometry}
				material={materials["Material.014"]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube117.geometry}
				material={materials["Material.014"]}
				position={[2.203, 0.697, 2.543]}
				rotation={[Math.PI, 0, Math.PI]}
				scale={1.198}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube118.geometry}
				material={materials["Material.014"]}
				position={[1.39, 0.697, 1.717]}
				rotation={[Math.PI, 0, Math.PI]}
				scale={1.198}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube119.geometry}
				material={materials["Material.014"]}
				position={[-0.389, 0.673, 2.126]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder053.geometry}
				material={materials["Material.014"]}
				position={[-1.673, 0.937, 1.793]}
				rotation={[0, 0, -Math.PI]}
				scale={[-0.065, -0.397, -0.065]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube120.geometry}
				material={materials["Material.014"]}
				position={[-2.199, 0.14, 0.026]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder054.geometry}
				material={materials["Material.014"]}
				position={[-2.711, 0.075, -0.769]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.021, 0.381, 0.021]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder055.geometry}
				material={materials["Material.014"]}
				position={[-2.482, 0.075, -0.769]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.021, 0.381, 0.021]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder056.geometry}
				material={materials["Material.014"]}
				position={[-2.28, 0.075, -0.769]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.021, 0.381, 0.021]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder057.geometry}
				material={materials["Material.014"]}
				position={[-2.095, 0.075, -0.769]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.021, 0.381, 0.021]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder058.geometry}
				material={materials["Material.014"]}
				position={[-1.902, 0.075, -0.769]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.021, 0.381, 0.021]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder059.geometry}
				material={materials["Material.014"]}
				position={[-1.747, 0.075, -0.769]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={[0.021, 0.381, 0.021]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube121.geometry}
				material={materials["Material.014"]}
				position={[-2.356, 0.638, 2.138]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane023.geometry}
				material={materials["Material.014"]}
				position={[-0.165, 0.088, 0.826]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane024.geometry}
				material={materials["Material.014"]}
				position={[-0.165, 0.088, 1.033]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane025.geometry}
				material={materials["Material.014"]}
				position={[2.068, 0.088, 1.033]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder060.geometry}
				material={materials["Material.014"]}
				position={[-2.503, 0.155, 0.979]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder061.geometry}
				material={materials["Material.014"]}
				position={[0.156, 0.956, -0.058]}
				scale={[0.064, 0.176, 0.064]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Lowpoly_building.geometry}
				material={materials["Material.014"]}
				position={[1.637, -0.204, -1.937]}
				scale={0.063}
			>
				<mesh
					castShadow
					receiveShadow
					geometry={nodes.Cube103.geometry}
					material={materials["Material.014"]}
				/>
			</mesh>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.House.geometry}
				material={materials["Material.014"]}
				position={[1.846, -0.007, -1.431]}
				rotation={[Math.PI, 0, Math.PI]}
				scale={[0.47, 0.239, 0.239]}
			/>
		</group>
	);
}

useGLTF.preload("models/portugal.glb");
